import { render, staticRenderFns } from "./RegistroCasamentoLegado.vue?vue&type=template&id=a1095cfa&scoped=true&"
import script from "./RegistroCasamentoLegado.vue?vue&type=script&lang=js&"
export * from "./RegistroCasamentoLegado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1095cfa",
  null
  
)

export default component.exports